import { render, staticRenderFns } from "./SalaCalendario.vue?vue&type=template&id=640354e9&scoped=true"
import script from "./SalaCalendario.vue?vue&type=script&lang=js"
export * from "./SalaCalendario.vue?vue&type=script&lang=js"
import style0 from "./SalaCalendario.vue?vue&type=style&index=0&id=640354e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640354e9",
  null
  
)

export default component.exports